import React from "react";
import { connect } from "react-redux";

import {
  getPaymentByID,
  isPaymentOverdue
} from "state/school_money/selectors";

import Date from "components/Date";

import "./OfflineOnlyPaymentBody.css";

class OfflineOnlyPaymentBody extends React.Component {
  
  render() {
    
    const { payment, isOverdue } = this.props;
    const { dueDate } = payment.installments.first();
    
    const classNames = [ "payment-body", "offline-only-payment-body" ];
    if (isOverdue) {
      classNames.push("offline-only-payment-body--overdue");
    }
    
    return (
      <div className={classNames.join(" ")}>
        <div >
          <p>
            Due <span className="offline-only-payment-body__due-date"><Date date={dueDate} /></span>
          </p>
          <p className="offline-only-payment-body__message">
            Payment for this item can only be made in school. Please bring your payment into school.
          </p>
        </div>
      </div>
    )
    
  }
  
}

export default connect(
  (state, { paymentID }) => ({
    payment: getPaymentByID(state, paymentID),
    isOverdue: isPaymentOverdue(state, paymentID)
  })
)(OfflineOnlyPaymentBody);



// WEBPACK FOOTER //
// ./src/components/school_money/payments/OfflineOnlyPaymentBody.js